export default __webpack_public_path__ + "static/media/SingleHop.529adacd.png";